import { Box, Table, Text } from "@mantine/core";
import {
  IconArrowsUpDown,
  IconCircleMinus,
  IconCirclePlus,
  IconFlag,
  IconSeparatorHorizontal,
  IconTrophy,
} from "@tabler/icons-react";
import { Event, PoolMember } from "../../common/events/event.schema";
import { Swords } from "../../common/icons/swords";
import { Member } from "../../common/members/member.schema";
import Hider from "../common/Hider";
import MemberDisplay from "../members/MemberDisplay";
import MemberName from "../members/MemberName";
import { ColumnHeader } from "./PoolTable";
import { getIsEndless } from "./util";

const PoolResultsTable = ({ event }: { event: Event }) => {
  const results =
    event.eliminationSeeds?.length > 0 ? event.eliminationSeeds : event.results;
  const members = event.members as Member[];
  const poolMembers: PoolMember[] = [];
  const endless = getIsEndless(event);
  event.pools.map((p) => p.members.map((pm) => poolMembers.push(pm)));
  const rows = results.map((r) => {
    const pm = poolMembers.find((pm) => pm.member === r) as PoolMember;
    // console.log("pm :", pm);
    const wins = pm.wins || 0;
    const losses = pm.losses || 0;
    return {
      member: members.find((m) => m._id === r) as Member,
      pm: pm,
      vm: (wins / (wins + losses || 1)).toFixed(2),
      matchCount: wins + losses,
    };
  });
  const withdrawls = poolMembers.filter((pm) => pm.withdrawn);
  return (
    <Table fz="xs">
      <Table.Thead>
        <Table.Th></Table.Th>
        <Table.Th></Table.Th>
        <Table.Th>
          <ColumnHeader label="Wins" icon={<IconTrophy size={12} />} />
        </Table.Th>
        {!endless && (
          <Table.Th>
            <ColumnHeader
              label="Ratio"
              icon={<IconSeparatorHorizontal size={12} />}
            />
          </Table.Th>
        )}
        {endless && (
          <Table.Th>
            <ColumnHeader label="Matches" icon={<Swords size={12} />} />
          </Table.Th>
        )}
        <Table.Th>
          <ColumnHeader label="For" icon={<IconCirclePlus size={12} />} />
        </Table.Th>
        <Table.Th>
          <ColumnHeader label="Against" icon={<IconCircleMinus size={12} />} />
        </Table.Th>
        <Table.Th>
          <ColumnHeader
            label="Indicator"
            icon={<IconArrowsUpDown size={12} />}
          />
        </Table.Th>
      </Table.Thead>
      <Table.Tbody>
        {rows.map((row, i) => (
          <Table.Tr key={row.member?._id} style={{ pageBreakInside: "avoid" }}>
            <Table.Td>{i + 1}</Table.Td>
            <Table.Td>
              <Hider smallerThan={"md"}>
                <Box>
                  <MemberDisplay
                    avatar
                    size="xs"
                    member={row.member}
                    maxXS={10}
                  />
                </Box>
              </Hider>
              <Hider largerThan={"md"}>
                <Text size="xs">
                  <MemberName member={row.member} max={10} />
                </Text>
              </Hider>
            </Table.Td>
            <Table.Td align="center">{row.pm.wins || 0}</Table.Td>
            {!endless && <Table.Td align="center">{row.vm || 0}</Table.Td>}
            {endless && (
              <Table.Td align="center">{row.matchCount || 0}</Table.Td>
            )}
            <Table.Td align="center">{row.pm.for || 0}</Table.Td>
            <Table.Td align="center">{row.pm.against || 0}</Table.Td>
            <Table.Td align="center">{row.pm.diff || 0}</Table.Td>
          </Table.Tr>
        ))}
        {withdrawls.map((w) => {
          const member = members.find((m) => m._id === w.member) as Member;
          return (
            <Table.Tr key={w.member}>
              <Table.Td>
                <IconFlag size={13} />
              </Table.Td>
              <Table.Td>
                <Hider smallerThan={"md"}>
                  <Box>
                    <MemberDisplay
                      avatar
                      size="xs"
                      member={member}
                      maxXS={10}
                    />
                  </Box>
                </Hider>
                <Hider largerThan={"md"}>
                  <Text size="xs">
                    <MemberName member={member} max={10} />
                  </Text>
                </Hider>
              </Table.Td>
              <Table.Td></Table.Td>
              <Table.Td></Table.Td>
              <Table.Td></Table.Td>
              <Table.Td></Table.Td>
              <Table.Td></Table.Td>
            </Table.Tr>
          );
        })}
      </Table.Tbody>
    </Table>
  );
};
export default PoolResultsTable;
